import {
  isNonNullable
} from "./chunk-ARWLRO3D.mjs";

// lib/components/outside-click-handler/outside-click-handler/outside-click-handler.tsx
import { useRef } from "react";
import { useClickAway } from "react-use";
import { jsx } from "@emotion/react/jsx-runtime";
var OutsideClickHandler = ({
  excludeIds,
  onOutsideClick,
  children
}) => {
  const ref = useRef(null);
  useClickAway(ref, (e) => {
    if (isNonNullable(excludeIds)) {
      const parents = [];
      let current = e.target;
      while (current) {
        parents.push(current);
        current = current?.parentElement;
      }
      if (parents.some((elem) => excludeIds.includes(elem.id))) {
        return;
      }
    }
    onOutsideClick(e);
  });
  return /* @__PURE__ */ jsx("div", { ref, children });
};

export {
  OutsideClickHandler
};
